/**
 * DetailLayout.tsx
 * A reusable layout component that provides consistent spacing and padding
 * for all farm detail pages. This component ensures uniform layout across
 * different sections of the farm management system.
 */

import React from 'react';
import { Box } from '@mui/material';

/**
 * Props interface for the DetailLayout component
 * @property {React.ReactNode} children - The content to be rendered within the layout
 */
interface DetailLayoutProps {
  children: React.ReactNode;
}

/**
 * DetailLayout Component
 * Wraps content in a consistent layout with proper spacing and padding.
 * Used across all farm detail pages to maintain visual consistency.
 * 
 * Note: This component acts as a transparent wrapper to ensure full width.
 * It deliberately does not add extra padding or background to allow
 * the Dashboard/FarmLayout spacing to control the layout, matching the
 * main dashboard design.
 * 
 * @param {DetailLayoutProps} props - Component props
 * @returns {JSX.Element} - Rendered layout component
 */
const DetailLayout: React.FC<DetailLayoutProps> = ({ children }) => {
  return (
    <Box sx={{ width: '100%' }}>
      {children}
    </Box>
  );
};

export default DetailLayout;
